import React, { Component } from 'react';

import Group from './Group';
import Input from './Input';
import Label from './Label';
import Button from './Button';
import DatePicker from './DatePicker';
import Select from './Select';
import Slider from './Slider';
import Checkbox from './Checkbox';
import Radio from './Radio';

class Form extends Component {
  render() {
    return (
      <form {...this.props} className={this.props.className}>
        {this.props.children}
      </form>
    );
  }
}

Form.Group = Group;
Form.Input = Input;
Form.Label = Label;
Form.Button = Button;
Form.DatePicker = DatePicker;
Form.Select = Select;
Form.Slider = Slider;
Form.Checkbox = Checkbox;
Form.Radio = Radio;

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/index.js